import React from 'react';
import styles from './FieldFile.module.scss';
import { Control, Controller, FieldValues } from 'react-hook-form';
import { useTranslation } from '@app/i18n/useTranslationClient';

interface IFieldFile {
    fieldInput: React.ReactElement;
    formValues: FieldValues;
    control: Control;
    fieldName: string;
}

export const FieldFile = ({ fieldInput, fieldName, formValues, control }: IFieldFile) => {
    const { t } = useTranslation();

    return (
        <Controller
            control={control}
            name={fieldName}
            render={({ field: { value } }) => {
                return (
                    <div className={styles.file}>
                        <div className={styles.fileHidden}>{fieldInput}</div>
                        <div className={styles.fileFake}>
                            <input defaultValue={value?.[0]?.name || ''} readOnly />
                            <label htmlFor={fieldName}>
                                <div className={styles.fileButton}>{t('translations.forms.addFile')}</div>
                            </label>
                        </div>
                    </div>
                );
            }}
        />
    );
};
